import React from "react";
import Skeleton from "@material-ui/lab/Skeleton";
import { i18n } from "../../translate/i18n";

// Mirrors ContactDrawer's loaded layout (contactHero + section cards) so
// the skeleton occupies the same geometry and data landing doesn't cause
// a layout jump. Previously referenced classes (contactHeader/
// contactDetails/contactExtraInfo) that no longer exist in ContactDrawer's
// useStyles, rendering unstyled left-aligned Papers.
const ContactDrawerSkeleton = ({ classes }) => {
	return (
		<div className={classes.content}>
			{/* Contact identity — centered hero: 80px avatar, name, phone, edit btn */}
			<div className={classes.contactHero}>
				<Skeleton
					animation="wave"
					variant="circle"
					width={80}
					height={80}
				/>
				<Skeleton animation="wave" height={25} width={120} />
				<Skeleton animation="wave" height={20} width={100} />
				<Skeleton animation="wave" height={32} width={90} />
			</div>
			{/* Extra info section card */}
			<div className={classes.section}>
				<div className={classes.sectionHeader}>
					<Skeleton
						animation="wave"
						variant="rect"
						width={32}
						height={32}
						style={{ borderRadius: 10 }}
					/>
					<span className={classes.sectionTitle}>
						{i18n.t("contactDrawer.extraInfo")}
					</span>
				</div>
				<div className={classes.extraInfoItem}>
					<Skeleton animation="wave" height={20} width={60} />
					<Skeleton animation="wave" height={20} width={160} />
				</div>
				<div className={classes.extraInfoItem}>
					<Skeleton animation="wave" height={20} width={60} />
					<Skeleton animation="wave" height={20} width={160} />
				</div>
				<div className={classes.extraInfoItem}>
					<Skeleton animation="wave" height={20} width={60} />
					<Skeleton animation="wave" height={20} width={160} />
				</div>
			</div>
		</div>
	);
};

export default ContactDrawerSkeleton;
